module.exports = __webpack_public_path__ + "static/img/img4.9480383.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img4.jpg
// module id = wSF9
// module chunks = 101